export * from './indicator.component';
